/**
Ref: https://medium.com/front-end-weekly/html5-form-validation-in-react-65712f778196
     https://time2hack.com/form-with-react-html5-validations/
     https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation

Note: default props inputRef, onChange, error HelperText can be overridden by passing it in props
*/

import { DatePicker } from '@starberry/components';
import React, { useRef, useState } from 'react';
import InputField from 'core/components/InputField';

const DateTextField = (props) => {
  const { ref, doValidate, hasError, helperText, ...rest } = props;
  return (
    <InputField
      inputRef={ref}
      onChange={() => {
        doValidate();
      }}
      error={hasError}
      helperText={hasError ? helperText : ''}
      {...rest}
    />
  );
};

const FormDateField = (props) => {
  const [selectedDate, handleDateChange] = React.useState(() => {
    return props?.inputProps?.defaultValue; /* || new Date() */
  });

  const hasHelperText = props?.helperText;
  const [hasError, setHasError] = useState(false);
  const [helperText, setHelperText] = useState(props?.helperText);
  const ref = useRef(null);
  const doValidate = () => {
    // const valid = ref.current.checkValidity();
    const invalidMsg = ref.current.validationMessage;
    if (!hasHelperText && helperText !== invalidMsg && invalidMsg) {
      setHelperText(invalidMsg);
    }
    // if (hasError === valid) setHasError(!valid);
  };
  return (
    <DatePicker
      renderInput={(rest) => (
        <DateTextField
          ref={ref}
          doValidate={doValidate}
          hasError={hasError}
          helperText={hasError ? helperText : ''}
          {...props}
          {...rest}
        />
      )}
      value={selectedDate}
      onChange={handleDateChange}
    />
  );
};
export default FormDateField;
